import { FlexRowWrapper, FlexWrapper, GradiantButton1, Text5, Text6 } from "../../Common";
import { BossModeButton, BossModeExtraDiv, BossModeText, FeatureList, PricingCardWrapper, ProText, StarterText } from "./styles";
import ShinignStart from "../../../Assets/ShiningStar.svg" ; 
export const StarterCard = () => {
  return (
    <PricingCardWrapper>
      <StarterText>Starter</StarterText>
      <FlexRowWrapper justify={"center"}>
        <Text6
          style={{ justifySelf: "flex-start" }}
          margin={"0px"}
          color={"white"}
        >
          &#x20b9;
        </Text6>
        <StarterText fontSize={"4rem"} margin={"0px"}>
          320
        </StarterText>
        <Text6 style={{ alignSelf: "flex-end" }} margin={"0px"} color={"white"}>
          /mo
        </Text6>
      </FlexRowWrapper>
      <Text5 color={"white"} weight={700}>
        20,000 words
      </Text5>
      <Text6 color={"white"}>
        Have Escribelo write short-form copy using over 50+ skills such as
        headlines, descriptions, and bios.
      </Text6>
      <GradiantButton1
        color={"white"}
      >
        Sign up
      </GradiantButton1>
      <FeatureList>
        <li>
          7-day Money Back <br /> Guarantee
        </li>
      </FeatureList>
      <FlexWrapper
        width={"100%"}
        margin={"20px auto"}
        direction={"column"}
        align={"flex-start"}
      >
        <Text5 margin={"8px 0px"} color={"white"}>
          Starer Feature
        </Text5>
        <FeatureList margin={"2px 0px"}>
          <li>
            50+ Short-Form <br /> Copywriting Templates
          </li>
        </FeatureList>
      </FlexWrapper>

      <FlexWrapper width={"100%"} margin={"20px auto"} direction={"column"}>
        <Text5 margin={"8px 0px"} color={"white"}>
          And includes
        </Text5>
        <FeatureList margin={"2px 0px"}>
          <li>Unlimited Users</li>
          <li>5 Project Folders</li>
          <li>25+ Supported Languages</li>
          <li>Chat Support</li>
          <li>Unlimited Users</li>
          <li>5 Project Folders</li>
        </FeatureList>
      </FlexWrapper>
    </PricingCardWrapper>
  );
};


export const BossModeCard = () => {
  return (
    <PricingCardWrapper backgroundColor={"#49005C"} padding={"0px"}>
      <BossModeExtraDiv />
      <PricingCardWrapper backgroundColor={"#49005C"}>
        <FlexWrapper direction={'column'} align={'center'}>
          <FlexRowWrapper justify={"center"}>
            <img
              src={ShinignStart}
              style={{ width: "25px", height: "25px" }}
            ></img>
            <Text6 color={"white"} margin={"0px 4px"}>
              New features!
            </Text6>
          </FlexRowWrapper>
          <BossModeText style={{ margin: "0px" , fontWeight : 800 }}>Boss Mode</BossModeText>
        </FlexWrapper>

        <FlexRowWrapper justify={"center"}>
          <Text6
            style={{ justifySelf: "flex-start" }}
            margin={"0px"}
            color={"white"}
          >
            &#x20b9;
          </Text6>
          <BossModeText fontSize={"4rem"} margin={"0px"}>
            899
          </BossModeText>
          <Text6
            style={{ alignSelf: "flex-end" }}
            margin={"0px"}
            color={"white"}
          >
            /mo
          </Text6>
        </FlexRowWrapper>
        <Text5 color={"white"} weight={700}>
          Unlimited words
        </Text5>
        <Text6 color={"white"}>
          Write 2x faster and gain control by using Escribelo Command to direct
          the AI to write exactly what you need.
        </Text6>
        {/* <GradiantButton1 color={"white"}>Sign up</GradiantButton1> */}
        <BossModeButton>Sign Up</BossModeButton>
        <FeatureList>
          <li>
            7-day Money Back <br /> Guarantee
          </li>
        </FeatureList>
        <FlexWrapper
          width={"100%"}
          margin={"20px auto"}
          direction={"column"}
          align={"flex-start"}
        >
          <Text5 margin={"8px 0px"} color={"white"}>
            Starer Feature
          </Text5>
          <FeatureList margin={"2px 0px"}>
            <li>
              50+ Short-Form <br /> Copywriting Templates
            </li>
          </FeatureList>
        </FlexWrapper>

        <FlexWrapper width={"100%"} margin={"20px auto"} direction={"column"}>
          <Text5 margin={"8px 0px"} color={"white"}>
            And includes
          </Text5>
          <FeatureList margin={"2px 0px"}>
            <li>Unlimited Users</li>
            <li>5 Project Folders</li>
            <li>25+ Supported Languages</li>
            <li>Chat Support</li>
            <li>Unlimited Users</li>
            <li>5 Project Folders</li>
            <li>Unlimited Users</li>
            <li>5 Project Folders</li>
            <li>5 Project Folders</li>
          </FeatureList>
        </FlexWrapper>
      </PricingCardWrapper>
    </PricingCardWrapper>
  );
};


export const ProCard = () => {
  return (
    <PricingCardWrapper>
      <ProText>Pro</ProText>
      <FlexRowWrapper justify={"center"}>
        <Text6
          style={{ justifySelf: "flex-start" }}
          margin={"0px"}
          color={"white"}
        >
          &#x20b9;
        </Text6>
        <ProText fontSize={"4rem"} margin={"0px"}>
          750
        </ProText>
        <Text6 style={{ alignSelf: "flex-end" }} margin={"0px"} color={"white"}>
          /mo
        </Text6>
      </FlexRowWrapper>
      <Text5 color={"white"} weight={700}>
        Unlimited words
      </Text5>
      <Text6 color={"white"}>
        Unlock Escribelo to write long-form content such as blog posts, video
        scripts, and books.
      </Text6>
      <GradiantButton1
        color={"white"}
      >
        Sign up
      </GradiantButton1>
      <FeatureList>
        <li>
          7-day Money Back <br /> Guarantee
        </li>
      </FeatureList>
      <FlexWrapper
        width={"100%"}
        margin={"20px auto"}
        direction={"column"}
        align={"flex-start"}
      >
        <Text5 margin={"8px 0px"} color={"white"}>
          Pro Feature
        </Text5>
        <FeatureList margin={"2px 0px"}>
          <li>
            50+ Short-Form <br /> Copywriting Templates
          </li>
        </FeatureList>
      </FlexWrapper>

      <FlexWrapper width={"100%"} margin={"20px auto"} direction={"column"}>
        <Text5 margin={"8px 0px"} color={"white"}>
          And includes
        </Text5>
        <FeatureList margin={"2px 0px"}>
          <li>Unlimited Users</li>
          <li>5 Project Folders</li>
          <li>25+ Supported Languages</li>
          <li>Chat Support</li>
          <li>Unlimited Users</li>
          <li>5 Project Folders</li>
          <li>25+ Supported Languages</li>
          <li>Chat Support</li>
          <li>Unlimited Users</li>
        </FeatureList>
      </FlexWrapper>
    </PricingCardWrapper>
  );
};